import React, { useCallback } from 'react';
import { useModalStore, useAuthStore } from '@/store';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';

const TasksBrowseRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  const { openModal } = useModalStore(state => state.actions);
  const isGhost = useAuthStore(state => state.user?.flags?.isGhost);
  const isPlus = useAuthStore(state => state.user?.flags?.isPlus);

  const handleCreateClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isGhost) {
      openModal('GhostSignupModal');
    } else if (isPlus) {
      openModal('CreateTaskModal');
    } else {
      openModal('PricingModal');
    }
  }, [openModal, isGhost, isPlus]);

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="plus"
        tooltip={t('nav.routes.tasksBrowse.newTask')}
        label={isXS ? undefined : t('nav.routes.tasksBrowse.newTask')}
        onPress={handleCreateClick}
      />
    </NavigationBarButtonContainer>
  );
});

TasksBrowseRouteNavigationHeaderRight.displayName = 'TasksBrowseRouteNavigationHeaderRight';

const TasksBrowseRouteNavigationOptions = {
  title: 'Browse Task Templates',
  headerTitle: 'Browse Task Templates',
  headerBackVisible: false,
  headerRight: () => <TasksBrowseRouteNavigationHeaderRight />,
};

export default TasksBrowseRouteNavigationOptions;
